import { useContext, useState } from "react";
import { textes } from "../../constants/textes";
import ForfaitSouscrits from "../../components/souscriptions/sousforfaits";
import AbonnementSouscrits from "../../components/souscriptions/sousabonnements";
import UserContext from "../../contexts/UserContext";



export default function SouscriptionsView() {
    // states
    const { user } = useContext(UserContext);
    const [page, setPage] = useState(0);

    const displayPages = () => {
        if (page === 0) {
            return <ForfaitSouscrits />;
        } else {
            return <AbonnementSouscrits />;
        }
    }

    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary"><i className="fa fa-gift mr-1"></i> {textes.fr.souscriptionslabel}</h1>
            {(user?.isFullAction || user.isAdminAction) && <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.forfaitslabel}</span>
                </button>
                <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.abonnementslabel}</span>
                </button>
            </div>}
            {displayPages()}
        </div>
    )

}